<template>
  <b-form-select
    v-model="_value"
    :disabled="disabled"
    :options="options" />
</template>

<script>
import format from 'date-fns/format'
import addYears from 'date-fns/addYears' 
import addMonths from 'date-fns/addMonths' 
export default {
  props: {
    value: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _value: {
      get() { return this.value },
      set(value) { this.$emit('input', value) }
    }
  },
  created() {
    this.setYearMonthOptions()
  },
  methods: {
    setYearMonthOptions() {
      let yearMonthOptions = []
      const today = new Date()
      this.selectedYearMonth = format(today, 'yyyy-MM')
      let currentDate = addYears(today, -6)
      const endDate = addYears(today, 6)
      while (currentDate <= endDate) {
        const yearMonthOption = {
          value: format(currentDate, 'yyyy-MM'),
          text: format(currentDate, 'yyyy年M月'),
        }
        yearMonthOptions = [...yearMonthOptions, yearMonthOption]
        currentDate = addMonths(currentDate, 1)
      }

      this.options = yearMonthOptions
    },
  }
}
</script>